<template>
  <v-dialog
    v-if="bed"
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-container
        :class="{
          'px-10': !mobile,
          'pt-8': !mobile,
          'pa-4': mobile
        }"
      >
        <p class="subtitle-1 font-weight-bold mb-2">
          Add/Remove Unit Tags: {{ bed.bedName }}
        </p>
        <v-row>
          <v-col class="pb-0" cols="12" sm="12" md="12">
            <autocomplete-tags
              :items="property.tags"
              :tags="tags"
              unit-type="unit"
              :bed-id="bedId"
              @addTag="onAddTag"
              @addTagError="onAddTagError"
            ></autocomplete-tags>
          </v-col>
        </v-row>
        <v-card-actions :class="{ 'pa-0': mobile }">
          <v-spacer></v-spacer>
          <v-btn
            class="font-weight-bold"
            color="primary darken-1"
            text
            @click="finish"
            >Close</v-btn
          >
        </v-card-actions>
      </v-container>
    </v-card>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import AutocompleteTags from './AutocompleteTags.vue'
export default {
  components: {
    AutocompleteTags
  },
  data() {
    return {
      dialog: false,
      options: {
        color: 'primary',
        width: 500,
        zIndex: 200
      },
      loading: true,
      tags: null,
      bedId: null,
      snackbar: false,
      snackbarText: null,
      bed: null
    }
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.xs
    },
    property() {
      return this.$store.getters['properties/getProperty']
    }
  },
  methods: {
    async open(bed) {
      this.bed = bed
      this.bedId = bed.bedId
      const tags = await this.$store.dispatch(
        'units/getUnitTagAction',
        this.bedId
      )
      this.tags = tags.data

      this.loading = false
      this.dialog = true

      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    async finish() {
      this.dialog = false
      this.$root.$setLoading(false)
      this.resolve(true)
    },
    onAddTag(tagToPushUI) {
      this.$emit('addTag', tagToPushUI)
    },
    onAddTagError(error) {
      this.snackbarText = error
      this.snackbar = true
    }
  }
}
</script>

<style scoped>
p {
  margin-bottom: 0;
}
</style>
